import * as UI from "@iyk/ui"
import * as React from "react"

import { HowToTapStorage } from "./profile-storage.ts"
import { Sheet } from "./sheet.tsx"

export const HowToTapDialog = ({ background, video }: HowToTapDialog.Props) => {
  const [isOpen, setIsOpen] = React.useState(false)
  const [seenForTheFirstTime, setSeenForTheFirstTime] = React.useState(false)

  React.useEffect(() => {
    setIsOpen(!HowToTapStorage.hasBeenViewed())
  }, [])

  const handleOpenChange = (open: boolean) => {
    setIsOpen(open)
    if (open === false && !HowToTapStorage.hasBeenViewed()) {
      HowToTapStorage.markAsViewed()
      setSeenForTheFirstTime(true)
    }
  }

  return (
    <Sheet.Root open={isOpen} onOpenChange={handleOpenChange}>
      <Sheet.Trigger className="relative flex items-center justify-between border border-white/5 rounded p-3 overflow-hidden">
        <img src={background} alt="Tap to learn more" className="size-full object-cover absolute inset-0" />
        <span className="uppercase text-gray-12 text-[16px] leading-[18.1px] tracking-[-0.09px] font-magda-plain text-left">
          Did you know this merch <br /> unlocks rewards?
        </span>
        <UI.Icon.InfoCircled />
      </Sheet.Trigger>
      <Sheet.Content
        title="Tap to learn more"
        description="Tap to learn more about the Sickness 25th Anniversary Tour merch."
      >
        <div className="relative">
          {!seenForTheFirstTime && (
            <img
              src={background}
              alt="Tap to learn more"
              className="size-full object-fill absolute inset-0 -z-10"
            />
          )}
          <div className="flex flex-col gap-6 px-4 py-8">
            {seenForTheFirstTime ? (
              <h3 className="text-xl">Claim merch to activate</h3>
            ) : (
              <h3 className="uppercase text-gray-12 text-[18px] leading-[21px] tracking-[-0.09px] font-magda-plain text-center">
                Did you know this merch <br /> unlocks rewards?
              </h3>
            )}
            <video
              src={video}
              className="size-full aspect-video"
              preload="metadata"
              playsInline
              controls
              autoPlay
              muted
            />
            <p className={UI.cx("text-sm", !seenForTheFirstTime && "text-center")}>
              Tap "The Guy" on your merch to claim your item and access exclusive unlocks.
            </p>
            {!seenForTheFirstTime && (
              <UI.Button
                type="button"
                kind="solid"
                size="lg"
                className="w-full"
                onClick={() => handleOpenChange(false)}
              >
                Got it
              </UI.Button>
            )}
          </div>
        </div>
      </Sheet.Content>
    </Sheet.Root>
  )
}

namespace HowToTapDialog {
  export type Props = {
    video: string
    background: string
  }
}
